import { getAdvertDate } from "helpers";
import React from "react";
import { truncateText, resolveOwnerName } from "helpers";

function getInitials(fullName) {
  const parts = (fullName || "").trim().split(/\s+/);
  const first = parts[0] ? parts[0][0] : "";
  const second = parts[1] ? parts[1][0] : "";
  return `${first}${second}`.toUpperCase() || "?";
}

function ChatroomItem({ item, history, currentUserId, activeId, onDelete }) {
  const participant = item?.participants?.[0];
  const participantName = resolveOwnerName(participant, item?.advert?.advertNo);
  const isUnread =
    item?.lastMessage &&
    item?.lastMessage?.receiver == currentUserId &&
    !item?.lastMessage?.seen;
  const isActive = activeId && item?._id == activeId;

  return (
    <div
      className={`chatroom-item ${isUnread ? "chatroom-item--unread" : ""} ${
        isActive ? "chatroom-item--active" : ""
      }`}
      onClick={() =>
        history.push(`/messages/${item?._id}?advert=${item?.advert?.slug}`)
      }
    >
      <div className="chatroom-avatar">{getInitials(participantName)}</div>

      <div className="chatroom-body">
        <div className="chatroom-top-row">
          <p className="chatroomName">{participantName}</p>
          <span className="lastMessageDate">
            {getAdvertDate(item?.lastMessage?.createdAt)}
          </span>
        </div>

        <p className="chatroomAdvertTitle">{item?.advert?.title}</p>

        <div className="chatroom-bottom-row">
          <span className="chatroom-preview">
            {truncateText(item?.lastMessage?.body, 42)}
          </span>
          {isUnread ? <div className="unreadDot" /> : null}
        </div>
      </div>

      <button
        className="chatroomDeleteIcon"
        onClick={(e) => {
          e.stopPropagation();
          onDelete(item);
        }}
        title="Sohbeti sil"
      >
        <i className="fa fa-trash" />
      </button>
    </div>
  );
}

export default ChatroomItem;
